import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createStyles, Input, makeStyles, Theme } from "@material-ui/core";
import React, { createRef, useCallback } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    search: {
      cursor: "pointer",
    },
  })
);

interface Props {
  placeholder?: string;
  defaultValue?: string;
  onSearchUpdate: (term: string) => void;
}

export const Search: React.FC<Props> = ({
  placeholder,
  onSearchUpdate,
  defaultValue,
}) => {
  const classNames = useStyles();
  const searchInput = createRef<HTMLInputElement>();

  const onSearch = useCallback(
    (event: any) => {
      const current = searchInput.current;
      if (!!current) {
        onSearchUpdate(current.value);
      }
    },
    [onSearchUpdate, searchInput]
  );

  return (
    <React.Fragment>
      <Input
        onChange={onSearch}
        placeholder={placeholder}
        fullWidth={true}
        value={defaultValue}
        inputRef={searchInput}
        endAdornment={
          <FontAwesomeIcon
            className={classNames.search}
            icon={faSearch}
            onClick={onSearch}
          />
        }
      />
    </React.Fragment>
  );
};
